import React from 'react';
import RcTable from 'rc-table';
import './Table.scss';

const Table = ({ columns, data, ...rest }) => {
  return <RcTable prefixCls="table" columns={columns} data={data} {...rest} />;
};

export default Table;
